import Vue from 'vue'
import VueRouter from 'vue-router'
import store from "@/store"
import {routeList} from "@/utils"

Vue.use(VueRouter)

// 防止连续点击多次路由报错
let routerPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location) {
  return routerPush.call(this, location).catch(err => err)
}

const router = new VueRouter({
  mode: 'history',
  routes: [{
    path: '/',
    redirect: 'main'
  }, {
    path: '/main',
    component: () => import('@/views/main/index'),
    redirect: 'home',
    children: [
      {
        path: '/home',
        component: () => import('@/views/home/index'),
      },
      {
        path: '/histopathology',
        component: () => import('@/views/histopathology/index'),
      },
      {
        path: '/immunohistochemistry',
        component: () => import('@/views/immunohistochemistry/index'),
      },
      {
        path: '/histochemistry',
        component: () => import('@/views/histochemistry/index'),
      },
      {
        path: '/analysis',
        component: () => import('@/views/analysis/index'),
      },
      {
        path: '/equipment',
        component: () => import('@/views/equipment/index'),
      },
      {
        path: '/publications',
        component: () => import('@/views/publications/index'),
      }
    ]
  }]
});

// 全局监听路由
router.beforeEach((to, from, next) => {
  let data = routeList.find(item => `/${item.url}` === to.path)
  store.commit('SET_ACTIVE', data.key)
  next();
});

export default router
